import { useTheme } from '@emotion/react';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Grid, Pagination, Stack, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import { alpha, styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Avatar from 'antd/es/avatar/avatar';
import { getApiCall } from 'api/apiService';
import Dp from 'assets/dummy/buy.jpg';
import {
  displayFlex,
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import { GET_BINDERID } from 'constant/app.config';
import { datacontext } from 'modules/AppLayout/AppLayout';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { poppins400, poppins500 } from 'theme/common.style';
import { OfferContainer } from './BuyerRegistration.util';
import BadgeButton, { getColor } from './components/BadgeButton';
import TableDropdown from './components/TableDropdown';
import { WarningLite } from './components/WarningLite';
import PendingCounterPrivatePopup from './components/PendingCounterPopup';

function EnhancedTableHead(props) {
  const {
    numSelected,
    onRequestSort,
    buyeroffer,
    tableData,
    vendorstatustable,
    setForwardOfferCheckList,
    forwardOfferCheckList,
    tableChecked,
    setTableChecked,
    propertyDetails,
    vendorside,
    forwardBuyersOfferToOtherBuyersui,
    tableCheckedpopup,
    setTableCheckedpopup,
    selectCheckBox,
    buyerRegisterCheckBox,
    setBuyerRegisterChecked,
    buyerRegisterChecked,
    selectedUserNames,
    setSelectedUserNames,
    selectedUserSurNames,
    setSelectedUserSurNames,
    forwardbuyernotify,
    StageTwo,
    selectedOfferUniqueIds,
    setSelectedOfferUniqueIds,
    eligibleUserIds,
    openPendingDialog,
    setOpenPendingDialog,
    setSelectAllTriggered,
    setTempCheckedIds,
    privateOfferDetails,
    VendorForward,
    vendorCounterPrice,
    multipleChkCounter,
    mobileView,
    formattedOfferPriceVendor,
  } = props;

  const anyEnabledRow = eligibleUserIds?.length > 0;

  return (
    <TableHead sx={{ width: '100%' }}>
      <TableRow sx={{ width: '100%' }}>
        <TableCell padding="checkbox" sx={{ width: '0.5%' }}>
          <Typography style={{ padding: '20px 5px 20px 10px' }}>
            <input
              type="checkbox"
              checked={
                anyEnabledRow &&
                eligibleUserIds?.every((id) =>
                  forwardOfferCheckList?.includes(id)
                )
              }
              indeterminate={
                anyEnabledRow &&
                eligibleUserIds?.some((id) =>
                  forwardOfferCheckList?.includes(id)
                ) &&
                !eligibleUserIds?.every((id) =>
                  forwardOfferCheckList?.includes(id)
                )
              }
              disabled={!anyEnabledRow}
              onChange={(e) => {
                const isChecked = e.target.checked;

                const eligibleRows = tableData?.filter((row) =>
                  eligibleUserIds.includes(row?.buyerDetails?.user?.userId)
                );

                const hasPending = eligibleRows
                  .filter((row) => {
                    const status = row?.isExistPendingOffer;
                    const offerStatusCode =
                      row?.buyerOfferDetails?.offerStatusCode;

                    return (
                      (status == 'Counter Pending' ||
                        status === 'Private Pending') &&
                      offerStatusCode !== 'BuyerAcc001' &&
                      offerStatusCode !== 'BuyerAccPrivate001'
                    );
                  })
                  .map((row) => row?.isExistPendingOffer);

                if (isChecked) {
                  if (hasPending.length > 0) {
                    const pendingTypes = [...new Set(hasPending)];

                    let currentAmount = '$0';
                    if (VendorForward) {
                      currentAmount = vendorCounterPrice;
                    } else if (multipleChkCounter && !mobileView) {
                      currentAmount =
                        props?.profileDetails?.latestcounterOfferPrice;
                    } else if (multipleChkCounter && mobileView) {
                      currentAmount = propertyDetails?.latestcounterOfferPrice;
                    } else {
                      currentAmount = formattedOfferPriceVendor;
                    }

                    setSelectAllTriggered(true);
                    setOpenPendingDialog({
                      open: true,
                      type: pendingTypes,
                      fromTableHead: true,
                      currentOfferAmount: currentAmount,
                      previousOfferAmount: null,
                      previousOfferType: null,
                      scenario: null,
                    });

                    return;
                  }
                  const newCheckList = eligibleRows.map(
                    (row) => row?.buyerDetails?.user?.userId
                  );

                  const newUserNames = eligibleRows.map(
                    (row) => row?.buyerDetails?.user?.userName || ''
                  );

                  const newUserSurNames = eligibleRows.map(
                    (row) => row?.buyerDetails?.user?.userSurName || ''
                  );

                  const newOfferIds = eligibleRows.map(
                    (row) => row?.buyerOfferDetails?.offerUniqueId || ''
                  );

                  setForwardOfferCheckList(newCheckList);
                  setSelectedUserNames(newUserNames);
                  setSelectedUserSurNames(newUserSurNames);
                  setSelectedOfferUniqueIds(newOfferIds);
                } else {
                  setForwardOfferCheckList([]);
                  setSelectedUserNames([]);
                  setSelectedUserSurNames([]);
                  setSelectedOfferUniqueIds([]);
                  setTempCheckedIds([]);
                }
              }}
            />
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
            color: '#666666',
            paddingLeft: '75px',
          }}
        >
          Name
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            width: '25%',
            color: '#666666',
          }}
        >
          Buyer Readiness
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
            color: '#666666',
          }}
        >
          Offer
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            // paddingRight: '80%',
            color: '#666666',
            width: '10%',
          }}
        >
          #Offers
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'center',
            width: '10%',
            whiteSpace: 'nowrap',
            color: '#666666',
          }}
        >
          Ratings
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
            color: '#666666',
            whiteSpace: 'nowrap',
          }}
        >
          Status
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.string.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        ></Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export const collectId = (
  tableData,
  id,
  setBuyerId,
  setPosition,
  setArrayCollection
) => {
  let arrayCollection = [];
  if (tableData?.length > 0) {
    for (let index = 0; index < tableData?.length; index++) {
      const element = tableData[index]?.buyerDetails?.user?.userId;
      arrayCollection.push(element);
    }
    setArrayCollection(arrayCollection);
    setBuyerId(id);

    let position = arrayCollection.indexOf(id);
    setPosition(position);
  }
};

const CircularProgressWithProfile = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{ color: '#C4C4C461' }}
        thickness={5}
        size={43}
      />
      <CircularProgress
        variant="determinate"
        value={props.value}
        sx={{ color: '#10D35E', position: 'absolute' }}
        thickness={5}
        size={43}
      />
      <Box
        sx={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          position: 'absolute',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
        >
          <Avatar
            alt="Remy"
            src={Dp}
            style={{
              width: '36px',
              height: '36px',
            }}
          />
        </Typography>
      </Box>
    </Box>
  );
};
const CircularProgressWithProfileVendor = ({ profileImage, name, value }) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        sx={{ color: '#C4C4C461' }}
        thickness={5}
        size={43}
      />
      <CircularProgress
        variant="determinate"
        value={value}
        sx={{ color: '#10D35E', position: 'absolute' }}
        thickness={5}
        size={43}
      />
      <Box
        sx={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          position: 'absolute',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
        >
          {profileImage == null || profileImage == '' ? (
            <Avatar
              style={{
                width: '36px',
                height: '36px',
                fontFamily: 'poppins',
                fontSize: '16px',
                backgroundColor: '#666666',
              }}
            >
              {name}
            </Avatar>
          ) : (
            <Avatar
              alt={name}
              src={profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default function EnhancedTable(props) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [updatefunc, setUpdatefunc] = useState(false);
  const [manageOffer, setManageOffer] = useState(false);
  const [isVendorHistoryId, setisVendorHistoryId] = useState(false);
  const { selectedBuyerid, openbuyercard, setOpenbuyercard } =
    useContext(datacontext);

  const {
    getListInfo,
    onShowChat,
    propertyDetails,
    stage,
    propertyidVendor,
    propertyId,
    forwardtootherbuyerstatus,
    selectedrowbuyeridfilter,
    setSelbuyerId,
    buyerpropertylist,
    getdata,
    userTypeValue,
    StageTwo,
    portraitMode,
    setIsSwalOpen,
    setMultipleChkCounter,
    counterOfferForwardHistory,
    multipleChkCounter,
    mobileView,
    counterOfferBuyerId,
    VendorForward,
    vendorCounterPrice,
    formattedOfferPriceVendor,
    privateOfferDetails,
    fullPropertyDetails,
  } = props;
  const [selectedBuyers, setSelectedBuyers] = React.useState([]);
  const [buyerId, setBuyerId] = React.useState('');
  const [userType, setUserType] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [isHiddenRightArrow, setIsHiddenRightArrow] = useState(true);
  const [selectedBuyerId, setSelectedBuyerId] = useState('');

  const [
    openforwardbuyeractiontovendorBox,
    setOpenForwardBuyerActionToVendorBox,
  ] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [row, setRow] = React.useState({});
  const [position, setPosition] = useState(0);
  const [arrayCollection, setArrayCollection] = useState([]);
  const useStyles = makeStyles({
    noSpinArrows: {
      '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
        {
          '-webkit-appearance': 'none',
          margin: 0,
        },
    },
    '@keyframes blink': {
      '0%': { backgroundColor: 'inherit', color: '#2F3F5E' },
      '50%': {
        background: 'linear-gradient(162.58deg, #e3e3e3 1.87%, #e3e3e3 98.78%)',
        color: 'white',
      },
      '100%': { backgroundColor: 'inherit', color: '#2F3F5E' },
    },
    blinking: {
      animation: `$blink 1s step-start infinite`,
    },
  });

  const classes = useStyles();
  const [highlight, setHighlight] = useState(false);
  useEffect(() => {
    if (selectedBuyerid != '') {
      setHighlight(true);
      const timer = setTimeout(() => {
        setHighlight(false);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [selectedBuyerid]);

  const handleMenuItemClick = (itemId) => {
    if (itemId === 1) {
      setShowModal(true);
    } else {
    }
  };

  const [buyerToVendorLoading, setBuyerToVendorLoading] = useState(false);
  const [anchorElBuyer, setAnchorElBuyer] = useState(null);
  const [anchorElProperty, setAnchorElProperty] = useState(null);
  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const [anchorElExp, setAnchorElExp] = useState(null);
  const [buyerName, setBuyerName] = useState('');
  const [buyerSurName, setBuyerSurName] = useState('');
  const [exp, setExp] = useState('');
  const [buyerReadinessValue, setBuyerReadinessValue] = useState();

  const buyerReadiness = (event, value, name, surname) => {
    setAnchorElBuyer(event.currentTarget);
    setBuyerReadinessValue(value);
    setBuyerName(name);
    setBuyerSurName(surname);
  };
  const openBuyer = Boolean(anchorElBuyer);
  const idBuyer = openBuyer ? 'simple-popover' : undefined;

  const openProperty = Boolean(anchorElProperty);
  const idProperty = openProperty ? 'simple-popover' : undefined;

  const openExp = Boolean(anchorElExp);
  const idExp = openExp ? 'simple-popover' : undefined;
  const openProfile = Boolean(anchorElProfile);
  const idProfile = openProfile ? 'simple-popover' : undefined;

  const {
    headCells,
    tableData,
    buyeroffer,
    vendorstatustable,
    address,
    vendorside,
    setForwardOfferCheckList,
    forwardOfferCheckList,
    selectedUserNames,
    setSelectedUserNames,
    selectedUserSurNames,
    setSelectedUserSurNames,
    forwardbuyernotify,
    vendorDatas,
    selectedOfferUniqueIds,
    setSelectedOfferUniqueIds,
  } = props;

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [indexValue, setIndexValue] = React.useState(null);
  const [userName, setUserName] = React.useState('');
  const [userMobile, setUserMobile] = React.useState('');
  const [userEmail, setUserEmail] = React.useState('');
  const [userAddress, setUserAddress] = React.useState('');
  const [userNoOfOffers, setUserNoOfOffers] = React.useState('');
  const [userPreviousOffer, setUserPreviousOffer] = React.useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalItems = tableData?.length || 0;
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.from(tableData || []).slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = tableData.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (isChecked, index, buyerId, row, userCategory) => {
    setIndexValue(index);
    setOpen(true);
    setBuyerId(buyerId);
    setSelbuyerId(buyerId);
    setRow(row);
    setUserName(row?.buyerDetails?.user?.userName);
    setUserMobile(row?.buyerDetails?.userMobile);
    setUserEmail(row?.buyerDetails?.userEmail);
    setUserAddress(row?.buyerDetails?.userAddress);
    setUserPreviousOffer(row?.buyerDetails?.previouslyOfferMade);
    setUserNoOfOffers(row?.buyerDetails?.noOfOffers);
    setIsHiddenRightArrow(true);
    const selectedIndex = selected.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    let userType = '';
    if (userCategory?.length > 1) {
      userType = 'Both';
    } else if (
      userCategory?.filter((e) => e.userType === 'Buyer')?.length > 0
    ) {
      userType = 'Buyer';
    }

    setSelected(newSelected);
    setUserType(userType);
    if (userType === 'Buyer') {
      if (isChecked) {
        setSelectedBuyers(
          (prevSelected) => [...prevSelected, buyerId],
          setOpen(isChecked)
        );
      } else {
        setSelectedBuyers((prevSelected) =>
          prevSelected.filter((id) => id !== buyerId, setOpen(false))
        );
      }
    }
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

  const handleClickBuyer = (buyerId, userType, row) => {
    setSelbuyerId(buyerId);
    setBuyerId(buyerId);
    setRow(row);
    setUserType(userType);
    setOpen(true);
    setIsHiddenRightArrow(true);
    setBuyerId(buyerId);
  };

  const [offerUniqueId, setOfferUniqueId] = useState('');
  const [tableChecked, setTableChecked] = useState(false);
  const [tableCheckedpopupui, setTableCheckedpopupui] = useState(false);
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const userType1 = userDetail?.primaryUserType;

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userType = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  React.useEffect(() => {
    setArrayCollection(arrayCollection);
  }, [arrayCollection]);
  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={props.rating * 10}
          sx={{ color: '#10D35E' }}
          thickness={5}
          size={45}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.rating == null ? 0 : props.rating}
          </Typography>
        </Box>
      </Box>
    );
  }
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 16,
    position: 'relative',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      background: '#FFFFFF',
      border: '0.81px solid',
      borderRadius: 2.42,
      borderColor: '#6C2AD2',
    },
    [`& .${linearProgressClasses.bar}`]: {
      background:
        'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
      borderRadius: 2.42,
      transition: 'none',
    },
  }));
  const TextOverlay = styled(Typography)(({ theme, leftPosition }) => ({
    position: 'absolute',
    top: '50%',
    left: `${leftPosition}%`,
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    fontSize: '10px',
    fontFamily: 'Poppins',
    color: '#FFFFFF',
    fontWeight: '400px',
    alignItems: 'center',
  }));

  function LinearProgressBarWithPercentage(props) {
    const rediness = props.rediness || 0;
    return (
      <div style={{ position: 'relative', cursor: 'pointer' }}>
        <BorderLinearProgress variant="determinate" value={props.value} />
        <TextOverlay
          sx={{ color: 'white', textShadow: '-1px 1px 0px black' }}
          variant="body2"
          color="textSecondary"
          leftPosition={'50%'}
        >
          {`${Math.round(props.value)}%`}
        </TextOverlay>
      </div>
    );
  }

  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [finalContract, setOpenFinalContract] = React.useState(false);
  const [BuyerDropdown, setBuyerDropdown] = React.useState(null);

  let finalCon;

  const [buyerRegisterCheckBox, setBuyerRegisterCheckBox] = useState([]);
  const [buyerRegisterCheckBoxArr, setBuyerRegisterCheckBoxArr] = useState([]);
  const [buyerRegisterChecked, setBuyerRegisterChecked] = useState(false);

  const selectCheckBox = (ids, flag) => {
    let selectedArr = [];
    let selectedWholeArr = [];
    if (flag != 'updateId') {
      for (let index = 0; index < tableData.length; index++) {
        const id = tableData[index]?.buyerDetails?.user?.userId;
        selectedArr.push(id);
        selectedWholeArr.push(tableData[index]);
      }

      if (buyerRegisterCheckBox?.length > 0 && buyerRegisterChecked) {
        setBuyerRegisterCheckBox([]);
        setBuyerRegisterCheckBoxArr([]);
      } else {
        setBuyerRegisterCheckBox(selectedArr);
        setBuyerRegisterCheckBoxArr(selectedWholeArr);
      }
    } else {
      setBuyerRegisterChecked(false);

      if (buyerRegisterCheckBox?.includes(ids)) {
        setBuyerRegisterCheckBox((prevArray) => {
          let index = prevArray.indexOf(ids);
          if (index !== -1) {
            prevArray.splice(index, 1);
          }
          const newArray = prevArray;
          return Array.from(new Set(newArray));
        });
        setBuyerRegisterCheckBoxArr((preArr) => {
          const filteredData = preArr.filter(
            (item) => item.buyerDetails.user.userId !== ids
          );

          return filteredData;
        });
      } else {
        setBuyerRegisterCheckBox((prevArray) => {
          const newArray = [...prevArray, ids];
          return Array.from(new Set(newArray));
        });
        let selectedWholeArr = [];
        for (let index = 0; index < tableData.length; index++) {
          const id = tableData[index]?.buyerDetails?.user?.userId;
          if (id == ids) {
            selectedWholeArr.push(tableData[index]);
          }
        }
        setBuyerRegisterCheckBoxArr((prevState) =>
          prevState ? [...prevState, ...selectedWholeArr] : selectedWholeArr
        );
      }
    }
  };

  const sendProps = (index, buyerId, row, userCategory, setShowBackDrop) => {};

  useEffect(() => {
    if (openbuyercard) {
      if (tableData) {
        if (Array.isArray(currentItems) && currentItems?.length > 0) {
          currentItems?.map((row, index) => {
            const buyerId = row?.buyerDetails?.user?.userId;
            const userType = row?.buyerDetails?.userCategory[0]?.userType;
            if (buyerId == selectedBuyerid) {
              handleClickBuyer(buyerId, userType, row);
            }
          });
        }
      }
    }
  }, [openbuyercard]);

  const manageOfferClickClose = () => {
    setManageOffer(false);
    setisVendorHistoryId(false);
  };

  useEffect(() => {
    const selectedUsers = tableData?.filter(
      (row) =>
        forwardOfferCheckList.includes(row?.buyerDetails?.user?.userId) &&
        !(
          mobileView
            ? propertyDetails?.counterOfferForwardHistory
            : props?.counterOfferForwardHistory
        )?.includes(row?.buyerDetails?.user?.userId) &&
        !!row?.buyerOfferDetails
    );

    setSelectedUserNames(
      selectedUsers?.map((row) => row?.buyerDetails?.user?.userName)
    );
    setSelectedUserSurNames(
      selectedUsers?.map((row) => row?.buyerDetails?.user?.userSurName)
    );
    setSelectedOfferUniqueIds(
      selectedUsers?.map((row) => row?.buyerOfferDetails?.offerUniqueId)
    );
  }, [forwardOfferCheckList, tableData]);

  const eligibleUserIds = tableData
    ?.filter((row) => {
      const offerStatusCode = row?.buyerOfferDetails?.offerStatusCode;
      const offerStatusVendorCode =
        row?.buyerOfferDetails?.offerStatusVendorCode;
      const shouldDisableByStatus =
        offerStatusCode == 'BuyerAcc001' ||
        offerStatusCode == 'BuyerAccPrivate001' ||
        (offerStatusCode == 'VendorAcc001' &&
          offerStatusVendorCode == 'BuyerNotAcc001');

      const userId = row?.buyerDetails?.user?.userId;

      if (shouldDisableByStatus || row?.buyerOfferPrice <= 0) return false;

      if (multipleChkCounter) {
        return mobileView
          ? !propertyDetails?.counterOfferForwardHistory?.includes(userId)
          : !counterOfferBuyerId?.includes(userId);
      } else {
        return !props?.counterOfferForwardHistory?.includes(userId);
      }
    })
    .map((row) => row?.buyerDetails?.user?.userId);

  const [openPendingDialog, setOpenPendingDialog] = useState({
    open: false,
    type: null,
  });
  const [selectAllTriggered, setSelectAllTriggered] = useState(false);
  const [tempCheckedIds, setTempCheckedIds] = useState([]);

  const handleCancel = () => {
    if (!selectAllTriggered && selectedBuyerId) {
      setForwardOfferCheckList((prev) =>
        prev.filter((id) => id !== selectedBuyerId)
      );
      setTempCheckedIds((prev) => prev.filter((id) => id !== selectedBuyerId));
    }

    setSelectedBuyerId(null);
    setOpenPendingDialog({
      open: false,
      type: null,
    });
    setSelectAllTriggered(false);
  };

  const handleContinue = () => {
    if (selectAllTriggered) {
      const eligibleRows = tableData?.filter((row) => {
        const userId = row?.buyerDetails?.user?.userId;
        return eligibleUserIds.includes(userId);
      });

      const newForwardIds = eligibleRows.map(
        (row) => row?.buyerDetails?.user?.userId
      );
      const newUserNames = eligibleRows.map(
        (row) => row?.buyerDetails?.user?.userName || ''
      );
      const newUserSurNames = eligibleRows.map(
        (row) => row?.buyerDetails?.user?.userSurName || ''
      );
      const newOfferIds = eligibleRows.map(
        (row) => row?.buyerOfferDetails?.offerUniqueId || ''
      );

      setForwardOfferCheckList(newForwardIds);
      setSelectedUserNames(newUserNames);
      setSelectedUserSurNames(newUserSurNames);
      setSelectedOfferUniqueIds(newOfferIds);
      setTempCheckedIds(newForwardIds);

      setSelectAllTriggered(false);
    } else {
      const selectedRow = tableData.find((row) => {
        const rowUserId = row?.buyerDetails?.user?.userId;
        return Number(rowUserId) === Number(selectedBuyerId);
      });

      if (!selectedRow) return;

      const name = selectedRow?.buyerDetails?.user?.userName || '';
      const surname = selectedRow?.buyerDetails?.user?.userSurName || '';
      const offerId = selectedRow?.buyerOfferDetails?.offerUniqueId || '';

      const updatedNames = selectedUserNames.includes(name)
        ? selectedUserNames
        : [...selectedUserNames, name];
      const updatedSurnames = selectedUserSurNames.includes(surname)
        ? selectedUserSurNames
        : [...selectedUserSurNames, surname];
      const updatedOfferIds = selectedOfferUniqueIds.includes(offerId)
        ? selectedOfferUniqueIds
        : [...selectedOfferUniqueIds, offerId];
      const updatedForwardIds = forwardOfferCheckList.includes(selectedBuyerId)
        ? forwardOfferCheckList
        : [...forwardOfferCheckList, selectedBuyerId];
      const updatedTempIds = tempCheckedIds.includes(selectedBuyerId)
        ? tempCheckedIds
        : [...tempCheckedIds, selectedBuyerId];

      setSelectedUserNames(updatedNames);
      setSelectedUserSurNames(updatedSurnames);
      setSelectedOfferUniqueIds(updatedOfferIds);
      setForwardOfferCheckList(updatedForwardIds);
      setTempCheckedIds(updatedTempIds);
    }

    setOpenPendingDialog({
      open: false,
      type: null,
    });
    setSelectedBuyerId(null);
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Paper
          sx={{
            width: '100%',
            mb: 2,
            boxShadow: 'none',
            border: matchessm ? 'none' : '1px solid #F0F0F0',
            borderRadius: '5px',
          }}
        >
          <TableContainer
            sx={{
              '-webkit-scrollbar': {
                display: 'none',
              },
              '-ms-overflow-style': 'none' /* IE and Edge */,
              'scrollbar-width': 'none',
            }}
          >
            <Table
              sx={{
                overflow: 'hidden',
              }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              <EnhancedTableHead
                buyeroffer={buyeroffer}
                headCells={headCells}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={tableData?.length}
                vendorstatustable={vendorstatustable}
                tableData={tableData}
                setForwardOfferCheckList={setForwardOfferCheckList}
                forwardOfferCheckList={forwardOfferCheckList}
                setTableChecked={setTableChecked}
                tableChecked={tableChecked}
                vendorside={vendorside}
                propertyDetails={propertyDetails}
                forwardBuyersOfferToOtherBuyersui={true}
                tableCheckedpopup={tableCheckedpopupui}
                setTableCheckedpopup={setTableCheckedpopupui}
                selectCheckBox={selectCheckBox}
                buyerRegisterCheckBox={buyerRegisterCheckBox}
                setBuyerRegisterCheckBox={setBuyerRegisterCheckBox}
                setBuyerRegisterChecked={setBuyerRegisterChecked}
                buyerRegisterChecked={buyerRegisterChecked}
                selectedUserNames={selectedUserNames}
                setSelectedUserNames={setSelectedUserNames}
                selectedUserSurNames={selectedUserSurNames}
                setSelectedUserSurNames={setSelectedUserSurNames}
                forwardbuyernotify={forwardbuyernotify}
                StageTwo={StageTwo}
                selectedOfferUniqueIds={selectedOfferUniqueIds}
                setSelectedOfferUniqueIds={setSelectedOfferUniqueIds}
                eligibleUserIds={eligibleUserIds}
                openPendingDialog={openPendingDialog}
                setOpenPendingDialog={setOpenPendingDialog}
                setSelectAllTriggered={setSelectAllTriggered}
                setTempCheckedIds={setTempCheckedIds}
                privateOfferDetails={privateOfferDetails}
                VendorForward={VendorForward}
                vendorCounterPrice={vendorCounterPrice}
                multipleChkCounter={multipleChkCounter}
                mobileView={mobileView}
                formattedOfferPriceVendor={formattedOfferPriceVendor}
              />
              <TableBody sx={{ width: '100%' }}>
                {tableData &&
                Array.isArray(currentItems) &&
                currentItems?.length > 0 ? (
                  currentItems?.map((row, index) => {
                    const buyerId = row?.buyerDetails?.user?.userId;
                    const getUserName = (userId) => {
                      const user = row?.buyerDetails?.user;
                      return user?.userName || 'Unknown';
                    };
                    const getUserSurName = (userId) => {
                      const user = row?.buyerDetails?.user;
                      return user?.userSurName || 'Unknown';
                    };

                    const offerStatusCode =
                      row?.buyerOfferDetails?.offerStatusCode;
                    const offerStatusVendorCode =
                      row?.buyerOfferDetails?.offerStatusVendorCode;

                    const shouldDisableByStatus =
                      offerStatusCode == 'BuyerAcc001' ||
                      offerStatusCode == 'BuyerAccPrivate001' ||
                      (offerStatusCode == 'VendorAcc001' &&
                        offerStatusVendorCode == 'BuyerNotAcc001');

                    const isPendingOffer =
                      row?.isExistPendingOffer == 'Counter Pending' ||
                      row?.isExistPendingOffer == 'Private Pending';

                    const isDisabledBase = multipleChkCounter
                      ? mobileView
                        ? propertyDetails?.counterOfferForwardHistory?.includes(
                            buyerId
                          ) ||
                          row?.buyerOfferPrice == 0 ||
                          shouldDisableByStatus
                        : counterOfferBuyerId?.some((id) => id == buyerId) ||
                          row?.buyerOfferPrice == 0 ||
                          shouldDisableByStatus
                      : props?.counterOfferForwardHistory?.includes(buyerId) ||
                        row?.buyerOfferPrice == 0 ||
                        shouldDisableByStatus;

                    const isDisabled = isPendingOffer
                      ? row?.buyerOfferPrice == 0 || shouldDisableByStatus // Check price/status even for pending offers
                      : isDisabledBase;

                    const pendingOfferType =
                      row?.isExistPendingOffer == 'Counter Pending'
                        ? 'Counter Pending'
                        : row?.isExistPendingOffer == 'Private Pending'
                        ? 'Private Pending'
                        : null;

                    const propertyOfferBuyerId =
                      row?.buyerOfferDetails?.offerUniqueId || buyerId;
                    const offerStatusVendor =
                      row?.buyerOfferDetails?.offerStatusVendor;
                    const offerStatus = row?.buyerOfferDetails?.offerStatus;
                    const isCardSelected = selectedBuyers.includes(buyerId);
                    const userType =
                      row?.buyerDetails?.userCategory[0]?.userType;
                    const userCategory = row?.buyerDetails?.userCategory;
                    const isItemSelected = isSelected(row.name);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    if (row?.buyerOfferDetails) {
                      if (
                        row?.buyerOfferDetails?.contractSignStatus ==
                        'Action Required'
                      ) {
                        finalCon = false;
                      } else if (
                        row?.buyerOfferDetails?.contractSignStatus ==
                        'E-sign Requested'
                      ) {
                        finalCon = false;
                      }
                    } else {
                      finalCon = true;
                    }

                    if (buyerId !== selectedrowbuyeridfilter) {
                      return (
                        <>
                          <TableRow
                            {...(!vendorside && {
                              sx: {
                                '& > *': { borderBottom: 'unset !important' },
                              },
                            })}
                            style={{
                              cursor: isDisabled ? 'default' : 'pointer',
                              opacity: isDisabled ? 0.5 : 1,
                              filter: 'none', // ✅ blur/grayscale disabled
                            }}
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.name}
                            className={
                              highlight &&
                              buyerId == selectedBuyerid &&
                              !openbuyercard
                                ? classes.blinking
                                : ''
                            }
                          >
                            <TableCell
                              padding="checkbox"
                              sx={{ width: vendorside ? '5%' : '1%' }}
                            >
                              <Typography
                                style={{ padding: '20px 5px 20px 10px' }}
                              >
                                <input
                                  type="checkbox"
                                  color="primary"
                                  checked={
                                    (multipleChkCounter
                                      ? mobileView
                                        ? !propertyDetails?.counterOfferForwardHistory?.includes(
                                            row?.buyerDetails?.user?.userId
                                          ) &&
                                          !shouldDisableByStatus &&
                                          row?.buyerOfferPrice !== 0 &&
                                          forwardOfferCheckList?.includes(
                                            row?.buyerDetails?.user?.userId
                                          )
                                        : !counterOfferBuyerId?.some(
                                            (id) =>
                                              id ==
                                              row?.buyerDetails?.user?.userId
                                          ) &&
                                          !shouldDisableByStatus &&
                                          row?.buyerOfferPrice !== 0 &&
                                          forwardOfferCheckList?.includes(
                                            row?.buyerDetails?.user?.userId
                                          )
                                      : !props?.counterOfferForwardHistory?.includes(
                                          row?.buyerDetails?.user?.userId
                                        ) &&
                                        !shouldDisableByStatus &&
                                        row?.buyerOfferPrice !== 0 &&
                                        forwardOfferCheckList?.includes(
                                          row?.buyerDetails?.user?.userId
                                        )) ||
                                    tempCheckedIds.includes(
                                      row?.buyerDetails?.user?.userId
                                    )
                                  }
                                  disabled={isDisabled}
                                  style={{
                                    cursor: multipleChkCounter
                                      ? mobileView
                                        ? propertyDetails?.counterOfferForwardHistory?.includes(
                                            row?.buyerDetails?.user?.userId
                                          ) ||
                                          row?.buyerOfferPrice == 0 ||
                                          shouldDisableByStatus
                                          ? 'default'
                                          : 'pointer'
                                        : counterOfferBuyerId?.some(
                                            (id) =>
                                              id ==
                                              row?.buyerDetails?.user?.userId
                                          ) ||
                                          row?.buyerOfferPrice == 0 ||
                                          shouldDisableByStatus
                                        ? 'default'
                                        : 'pointer'
                                      : props?.counterOfferForwardHistory?.includes(
                                          row?.buyerDetails?.user?.userId
                                        ) ||
                                        row?.buyerOfferPrice == 0 ||
                                        shouldDisableByStatus
                                      ? 'default'
                                      : 'pointer',
                                  }}
                                  inputProps={{ 'aria-labelledby': labelId }}
                                  onChange={(e) => {
                                    if (isDisabled) {
                                      e.preventDefault();
                                      return;
                                    }

                                    const userId =
                                      row?.buyerDetails?.user?.userId;
                                    const isBuyerAccepted =
                                      offerStatusCode == 'BuyerAcc001' ||
                                      offerStatusCode == 'BuyerAccPrivate001';

                                    if (isBuyerAccepted) {
                                      e.preventDefault();
                                      return;
                                    }

                                    if (
                                      pendingOfferType &&
                                      !isBuyerAccepted &&
                                      !forwardOfferCheckList?.includes(userId)
                                    ) {
                                      // Determine the scenario
                                      let scenario = '';

                                      // Get the previous offer amount based on the pending offer type
                                      let previousAmount = '$0';
                                      let previousOfferType =
                                        row?.isExistPendingOffer;

                                      if (
                                        previousOfferType === 'Counter Pending'
                                      ) {
                                        // For previous counter pending, get from buyerOfferDetails
                                        previousAmount =
                                          row?.buyerOfferDetails?.offerPrice ||
                                          '$0';
                                      } else if (
                                        previousOfferType === 'Private Pending'
                                      ) {
                                        // For previous private pending, get from privateOfferDetails prop
                                        let privateOfferPrice = null;

                                        // Try to get from privateOfferDetails prop
                                        if (
                                          privateOfferDetails?.privateOfferPrice
                                        ) {
                                          privateOfferPrice =
                                            privateOfferDetails.privateOfferPrice;
                                        }
                                        // If not found, try from fullPropertyDetails
                                        else if (
                                          fullPropertyDetails
                                            ?.privateOfferDetails
                                            ?.privateOfferPrice
                                        ) {
                                          privateOfferPrice =
                                            fullPropertyDetails
                                              .privateOfferDetails
                                              .privateOfferPrice;
                                        }

                                        previousAmount =
                                          privateOfferPrice || '$0';
                                      }

                                      let currentAmount = '$0';

                                      if (VendorForward) {
                                        currentAmount = vendorCounterPrice;
                                      } else if (
                                        multipleChkCounter &&
                                        !mobileView
                                      ) {
                                        currentAmount =
                                          props?.profileDetails
                                            ?.latestcounterOfferPrice;
                                      } else if (
                                        multipleChkCounter &&
                                        mobileView
                                      ) {
                                        currentAmount =
                                          propertyDetails?.latestcounterOfferPrice;
                                      } else {
                                        currentAmount =
                                          formattedOfferPriceVendor;
                                      }

                                      if (
                                        previousOfferType === 'Counter Pending'
                                      ) {
                                        scenario = 'counter-to-counter';
                                      } else if (
                                        previousOfferType === 'Private Pending'
                                      ) {
                                        const prevNum = parseFloat(
                                          previousAmount.replace(/[$,]/g, '')
                                        );
                                        const currNum = parseFloat(
                                          currentAmount.replace(/[$,]/g, '')
                                        );
                                        if (currNum < prevNum) {
                                          scenario = 'private-to-lower-counter';
                                        } else if (currNum > prevNum) {
                                          scenario =
                                            'private-to-higher-counter';
                                        } else {
                                          scenario = 'private-to-same-counter';
                                        }
                                      }

                                      setSelectedBuyerId(userId);
                                      setOpenPendingDialog({
                                        open: true,
                                        type: pendingOfferType,
                                        fromTableHead: false,
                                        previousOfferAmount: previousAmount,
                                        currentOfferAmount: currentAmount,
                                        previousOfferType: previousOfferType,
                                        scenario: scenario,
                                      });
                                      return;
                                    }

                                    if (tempCheckedIds?.includes(userId)) {
                                      setForwardOfferCheckList((prev) =>
                                        prev.filter((id) => id !== userId)
                                      );
                                      setTempCheckedIds((prev) =>
                                        prev.filter((id) => id !== userId)
                                      );
                                      return;
                                    }

                                    if (
                                      isDisabledBase &&
                                      isPendingOffer &&
                                      !isBuyerAccepted &&
                                      !forwardOfferCheckList?.includes(userId)
                                    ) {
                                      setSelectedBuyerId(userId);
                                      setOpenPendingDialog(true);
                                      return;
                                    }

                                    const isChecked = e.target.checked;

                                    setForwardOfferCheckList((prev) =>
                                      isChecked
                                        ? [...prev, userId]
                                        : prev.filter((id) => id !== userId)
                                    );

                                    setTempCheckedIds((prev) =>
                                      isChecked
                                        ? [...prev, userId]
                                        : prev.filter((id) => id !== userId)
                                    );
                                  }}
                                />
                              </Typography>
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="none"
                              sx={{ width: vendorside ? '17%' : '9%' }}
                            >
                              <Typography sx={userDetCont}>
                                <Typography sx={imageCont}>
                                  <Typography
                                    sx={displayFlex}
                                    style={{
                                      justifyContent: 'center',
                                      position: 'relative',
                                      alignItems: 'center',
                                      paddingRight: '10px',
                                    }}
                                  >
                                    <CircularProgressWithProfileVendor
                                      profileImage={
                                        row?.buyerDetails?.user?.userProfile
                                      }
                                      value={row?.buyerDetails?.profileActivity}
                                      name={
                                        row?.buyerDetails?.user?.userName?.charAt(
                                          0
                                        ) +
                                        row?.buyerDetails?.user?.userSurName?.charAt(
                                          0
                                        )
                                      }
                                    />
                                  </Typography>
                                  <Typography
                                    sx={(displayFlex, { cursor: 'pointer' })}
                                    aria-describedby={props.id}
                                  >
                                    <Typography
                                      sx={{
                                        ...poppins400,
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      {row?.buyerDetails?.user?.userName}{' '}
                                      {row?.buyerDetails?.user?.userSurName}
                                    </Typography>
                                  </Typography>
                                </Typography>
                              </Typography>
                            </TableCell>
                            <TableCell
                              align="center"
                              aria-describedby={idBuyer}
                              id={idBuyer}
                            >
                              <Box component={'div'}>
                                <LinearProgressBarWithPercentage
                                  id={idBuyer}
                                  value={row?.buyerDetails?.rediness}
                                  rediness={row?.buyerDetails?.rediness}
                                />
                              </Box>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ width: vendorside ? '20%' : '10%' }}
                            >
                              {
                                <OfferContainer
                                  row={row}
                                  data={row?.buyerOfferDetails?.offerPrice}
                                  agentReg={true}
                                  offerIsFinal={
                                    row?.buyerOfferDetails?.offerIsFinal
                                  }
                                  userTypeValue={userTypeValue}
                                  isMarket={row?.buyerOfferDetails?.isMarket}
                                />
                              }
                            </TableCell>
                            <TableCell
                              sx={{
                                ...poppins400,
                                fontSize: '14px',
                                width: '10%',
                              }}
                              align="left"
                            >
                              {row?.buyerDetails?.noOfOffers}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ width: vendorside ? '15%' : '10%' }}
                            >
                              <Typography
                                id={idProperty}
                                component="div"
                                sx={displayFlex}
                                style={{
                                  justifyContent: 'center',
                                  position: 'relative',
                                  alignItems: 'center',
                                  cursor: 'pointer',
                                }}
                              >
                                <CircularProgressWithLabel
                                  value={row?.buyerDetails?.interestedAvg}
                                  rating={row?.buyerDetails?.rating}
                                />
                                <CircularProgress
                                  value={100}
                                  variant="determinate"
                                  sx={{
                                    position: 'absolute',
                                    color: '#C4C4C461',
                                    ...poppins500,
                                    fontSize: '14px',
                                  }}
                                  thickness={5}
                                  size={45}
                                />
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Stack
                                direction={'row'}
                                alignItems={'center'}
                                justifyContent={'center'}
                              >
                                {row?.buyerOfferDetails != '' ? (
                                  <>
                                    <Grid
                                      container
                                      sx={{
                                        dsiplay: 'flex',
                                        flexDirection: 'column',
                                        gap: '15px',
                                      }}
                                    >
                                      <Grid item sx={{ cursor: 'pointer' }}>
                                        <div>
                                          <BadgeButton
                                            row={row}
                                            offerStatus={
                                              row?.buyerOfferDetails
                                                ?.offerStatus
                                            }
                                            offerStatusVendor={
                                              row?.buyerOfferDetails
                                                ?.offerStatusVendor
                                            }
                                            isnew={
                                              row?.buyerOfferDetails?.isNew
                                            }
                                          />
                                        </div>
                                      </Grid>
                                      {!row?.buyerOfferDetails
                                        ?.offerStatusVendor ||
                                        (row?.buyerOfferDetails
                                          ?.offerStatusVendor !== null && (
                                          <Grid item sx={{ cursor: 'pointer' }}>
                                            <Typography
                                              sx={{
                                                padding: '3px 10px',
                                                border: `1px solid ${getColor(
                                                  row?.buyerOfferDetails
                                                    ?.offerStatusVendor
                                                )}`,
                                                borderRadius: '17px',
                                                width: '135px',
                                                flexWrap: 'nowrap',
                                                whiteSpace: 'nowrap',
                                                fontFamily:
                                                  'Poppins !important',
                                                fontStyle: 'normal !important',
                                                fontWeight: '300 !important',
                                                fontSize: '12px !important',
                                                color: getColor(
                                                  row?.buyerOfferDetails
                                                    ?.offerStatusVendor
                                                ),
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                display: 'flex',
                                                gap: 0.5,
                                              }}
                                            >
                                              <WarningLite
                                                color={getColor(
                                                  row?.buyerOfferDetails
                                                    ?.offerStatusVendor
                                                )}
                                              />
                                              {
                                                row?.buyerOfferDetails
                                                  ?.offerStatusVendor
                                              }
                                            </Typography>
                                          </Grid>
                                        ))}
                                    </Grid>
                                  </>
                                ) : (
                                  <Grid item>
                                    <Typography textAlign={'left'}>
                                      {'-'}
                                    </Typography>
                                  </Grid>
                                )}
                              </Stack>
                            </TableCell>
                          </TableRow>

                          {!vendorside && (
                            <TableDropdown
                              propertyDetails={propertyDetails}
                              BuyerDropdown={BuyerDropdown}
                              index={index}
                              row={row}
                              key={index}
                              CircularProgressWithProfile={
                                CircularProgressWithProfile
                              }
                              directcomm={directcomm}
                            />
                          )}
                        </>
                      );
                    }
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colspan={12}
                      sx={{
                        textAlign: 'center',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                        fontSize: '10px',
                      }}
                    >
                      Buyer Not Available
                    </TableCell>
                  </TableRow>
                )}

                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 53 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {totalItems > 10 && (
            <Stack sx={{ float: 'right' }} style={{ color: '#6C2AD2' }}>
              <Pagination
                style={{
                  '& .MuiPaginationItem-root': {
                    color: '#9C9C9C',
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontWeight: '400px',
                    margin: -3,
                    padding: -3,
                  },
                  '& .MuiPaginationItem-root.Mui-selected': {
                    backgroundColor: 'white',
                    color: '#6C2AD2',
                  },

                  '& .MuiPaginationItem-icon': {
                    color: 'rgba(20, 20, 43, 1)',
                  },
                }}
                sx={{ p: '20px 0' }}
                count={Math.ceil(totalItems / 10)}
                page={currentPage}
                onChange={handlePageChange}
              />
            </Stack>
          )}
        </Paper>
      </Box>
      {openPendingDialog.open && (
        <PendingCounterPrivatePopup
          open={openPendingDialog.open}
          onClose={handleCancel}
          onContinue={handleContinue}
          address={address}
          tableData={tableData}
          pendingOfferType={openPendingDialog.type}
          fromTableHead={openPendingDialog.fromTableHead}
          previousOfferAmount={openPendingDialog.previousOfferAmount}
          currentOfferAmount={openPendingDialog.currentOfferAmount}
          previousOfferType={openPendingDialog.previousOfferType}
          scenario={openPendingDialog.scenario}
        />
      )}
    </>
  );
}
